import { render, staticRenderFns } from "./EstadisticasCategorias.vue?vue&type=template&id=beea78b4&scoped=true&lang=pug"
import script from "./EstadisticasCategorias.vue?vue&type=script&lang=js"
export * from "./EstadisticasCategorias.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCategorias.vue?vue&type=style&index=0&id=beea78b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beea78b4",
  null
  
)

export default component.exports